import { LockPercentOpenVariantOutlineIcon } from './LockPercentOpenVariantOutlineIcon';

/**
 * author: mocking-mike
 * id 8E4A2141-8B43-4CC8-9DC4-C48251A0ECCF
 * name lock-percent-open-variant-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-percent-open-variant-outline.svg
 * tags
 */
export const LockRateOpenVariantOutlineIcon = LockPercentOpenVariantOutlineIcon;
export default LockRateOpenVariantOutlineIcon